import { ElMessage } from 'element-plus'
import { useGetLanguage } from '@/hooks/useGetLanguage'
import i18n from '@/i18n'

// directives/animate.js
export default {
  mounted(el: HTMLDivElement, binding: any) {
    // 设置光标样式和提示
    el.style.cursor = 'pointer'

    // 添加点击事件监听器
    el.addEventListener('click', () => {
      // 获取要复制的文本
      const textToCopy = binding.value || el.textContent

      // 降级方案：使用老式方法
      const textarea = document.createElement('textarea')
      textarea.value = textToCopy
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)

      // 显示成功通知
      if (binding.instance) {
        ElMessage.success(i18n.global.t('system.text2'))
      }
    })
  },
}
